import React from "react"
import { Snackbar, Alert } from "@mui/material"
import { useSnackbar } from "@/shared/context/SnackbarContext"

const GlobalSnackbar: React.FC = () => {
  const { snackbar, hideSnackbar } = useSnackbar()
  const { open, message, type } = snackbar

  const handleClose = (_?: unknown, reason?: string) => {
    if (reason === "clickaway") return
    hideSnackbar()
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
      <Alert onClose={handleClose} severity={type} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default GlobalSnackbar
